module.exports = __webpack_public_path__ + "img/des_guzheng_1.6a963650.jpg";